export default "__VITE_ASSET__B30Xmdz4__"